import React from 'react';
import { ToggleButton } from './styles';

export const EditorToggleButton: React.FC<EditorToggleButtonProps> = ({
  onClick,
}) => {
  return (
    <ToggleButton onClick={onClick}>
      <img
        width="24"
        height="24"
        alt="Experiment Editor"
        src="https://cdn.pji.nu/g/logo/icon192x192.png"
      />
    </ToggleButton>
  );
};

interface EditorToggleButtonProps {
  onClick: () => void;
}
